import { ComponentRoute } from '@/classes'

const BookingCalendarRoutes = {
  DashboardView: new ComponentRoute('/capacity', 'Capacity Calendar')
}

export default BookingCalendarRoutes